<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.purchase-document-configuration.dialog.title' | translate"
		id="purchase-kind-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.purchase-document-configuration.dialog.form.name.label' | translate ">
							<ins-input
								[(ngModel)]="viewModel.documentName"
								id="purchase-kind-dialog-document-name"
								[placeholder]="'scenes.configuration.shared.purchase-document-configuration.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					@if (viewModel.isDefaultCalculationMethodVisible) {
						<div class="col-1">
							<ins-form-field
								[skl-focus-by]
								[label]="'scenes.configuration.shared.purchase-document-configuration.dialog.form.default-count-from.label' | translate">
								<ins-select
									display-text="label"
									id="purchase-kind-dialog-calculation-method"
									[converter]="viewModel.calculationMethodsConverter"
									[(ngModel)]="viewModel.bo.model.defaultCalculationMethod"
									[sklValidate]="getValidationKey('defaultCalculationMethod')">
									@for (item of viewModel.calculationMethods; track item) {
										<ins-option
											[value]="item">
											{{ item.label }}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
					}
					@if (viewModel.isDefaultDueDateVisible) {
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.purchase-document-configuration.dialog.form.default-payment-term.label' | translate">
								<ins-input
									rtl="false"
									id="purchase-kind-dialog-default-due-date"
									inputmode="decimal"
									[precision]="0"
									[placeholder]="'scenes.configuration.shared.purchase-document-configuration.dialog.form.default-payment-term.placeholder' | translate"
									[(ngModel)]="viewModel.bo.model.defaultDueDate"
									[sklValidate]="getValidationKey('defaultDueDate')">
								</ins-input>
								<div slot="end">{{this.l10n._T('scenes.configuration.shared.purchase-document-configuration.dialog.form.default-payment-term.' + (viewModel.bo.model.defaultDueDate === 1 ? 'day' : 'days'))}}</div>
								<div class="align--tiny-left" slot="end">
									<skl-icon
										[tooltip]="'scenes.configuration.shared.purchase-document-configuration.dialog.form.default-payment-term.purchase-e-invoice-info' | translate"
										color="secondary"
										shape="circle"
										name="help">
									</skl-icon>
								</div>
							</ins-form-field>
						</div>
					}
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="purchase-kind-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.configuration.shared.base.dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			typeName="accent"
			[spinner]="viewModel.isSaving"
			id="purchase-kind-dialog-save-button"
			(click)="onConfirmAsync()">
			{{'scenes.configuration.shared.base.dialog.buttons.save' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>